export default function MoreIcon({ className }: { className?: string }) {
  return (
    <svg
      className={`text-i-gray hover:text-i-black ${className}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99967 10.8337C10.4599 10.8337 10.833 10.4606 10.833 10.0003C10.833 9.54009 10.4599 9.16699 9.99967 9.16699C9.53944 9.16699 9.16634 9.54009 9.16634 10.0003C9.16634 10.4606 9.53944 10.8337 9.99967 10.8337Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.833 10.8337C16.2932 10.8337 16.6663 10.4606 16.6663 10.0003C16.6663 9.54009 16.2932 9.16699 15.833 9.16699C15.3728 9.16699 14.9997 9.54009 14.9997 10.0003C14.9997 10.4606 15.3728 10.8337 15.833 10.8337Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16634 10.8337C4.62658 10.8337 4.99967 10.4606 4.99967 10.0003C4.99967 9.54009 4.62658 9.16699 4.16634 9.16699C3.7061 9.16699 3.33301 9.54009 3.33301 10.0003C3.33301 10.4606 3.7061 10.8337 4.16634 10.8337Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const displayName = "MoreIcon";
